import { createTheme } from '@material-ui/core/styles'
import { DEFAULT_THEME_CONFIG } from '@scoir/mui-theme'
import { adaptV4Theme, createTheme as createThemeV5 } from '@mui/material'

const theme = createTheme(DEFAULT_THEME_CONFIG)

export const themeV5 = createThemeV5(
  adaptV4Theme({
    ...theme,
    breakpoints: theme.breakpoints,
    palette: theme.palette,
    typography: theme.typography,
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiCheckbox: {
        disableRipple: false,
      },
      MuiRadio: {
        disableRipple: false,
      },
      MuiSwitch: {
        disableRipple: false,
      },
      MuiCard: {
        elevation: 2,
      },
    },
    overrides: {
      MuiDataGrid: {
        root: {
          border: 'none',
          '.MuiDataGrid-columnHeaderCheckbox + .MuiDataGrid-columnHeader': {
            borderLeft: 'none',
          },
          '.MuiDataGrid-cellCheckbox + .MuiDataGrid-cell': {
            borderLeft: 'none',
          },
        },
        columnSeparator: {
          color: 'transparent',
          '$root &:hover': {
            color: 'inherit',
          },
        },
        columnHeaders: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          borderTop: `1px solid ${theme.palette.divider}`,
          background: '#F5F8FA',
        },
        columnHeader: {
          borderLeft: `1px solid ${theme.palette.divider}`,
          '&:focus': {
            outline: 'transparent',
          },
        },
        columnHeaderCheckbox: {
          borderLeft: 'none',
        },
        footerContainer: {
          borderTop: `1px solid ${theme.palette.divider}`,
          justifyContent: 'center',
        },
        cell: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          '&:focus': {
            outline: 'transparent',
          },
          '&--textLeft': {
            borderLeft: `1px solid ${theme.palette.divider}`,
          },
        },
        cellCheckbox: {
          borderLeft: 'none',
        },
      },
      MuiTablePagination: {
        selectLabel: {
          margin: '0px',
        },
        displayedRows: {
          margin: '0px',
        },
      },
    },
  }),
)

export default theme
